import { lazy } from 'react';

import { useIsClient } from '#/hooks/useIsClient';

export default function horizonLoadable(
  // oxlint-disable-next-line typescript/no-explicit-any
  importFn: () => Promise<any>,
  // oxlint-disable-next-line typescript/no-explicit-any
  options: { resolveComponent?: (module: any) => any; ssr?: boolean },
) {
  // oxlint-disable-next-line typescript/no-explicit-any
  const LazyComponent: any = lazy(() =>
    importFn().then((module) => ({
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      default: options.resolveComponent?.(module) ?? module.default,
    })),
  );

  if (options.ssr === false) {
    // oxlint-disable-next-line typescript/no-explicit-any
    function ClientOnlyLazyComponent(props: any) {
      const isClient = useIsClient();
      if (!isClient) return null;

      // eslint-disable-next-line react/jsx-props-no-spreading
      return <LazyComponent {...props} />;
    }

    ClientOnlyLazyComponent.load = () => {};

    return ClientOnlyLazyComponent;
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  LazyComponent.load = () => {};

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return LazyComponent;
}
